// 3rd party imports
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { observer } from 'mobx-react';

// Hooks
import { useStores } from 'hooks';

// Sources
import { AuthState } from 'sources';

type SignoutProps = RouteComponentProps;

const SignoutComponent = observer(
  // tslint:disable-next-line:no-shadowed-variable
  function SignoutComponent({ history }: SignoutProps) {
    const { userAuth, context } = useStores();
    const homePath = `/${context.locale}/home`;

    if (userAuth.authenticated === AuthState.UNKNOWN) {
      return null;
    }

    if (userAuth.authenticated === AuthState.TRUE) {
      userAuth.logout(homePath);
    } else {
      history.replace(homePath);
    }

    return null;
  },
);

export const Signout = withRouter(SignoutComponent);
